<template>
  <div :id="id" :class="componentClassName">
    <button class="a-notice-list-item__button" type="button" @click="handleClick(url)">
      <div class="a-notice-list-item__button-bg"></div>
      <i v-if="hasIndicator" class="a-notice-list-item__indicator" :style="indicatorStyle"></i>
      <div v-if="icon" class="a-notice-list-item__icon">
        <a-icon :icon="icon" :color="iconColor" />
      </div>
      <div class="a-notice-list-item__content">
        <i v-if="newFlag" class="a-notice-list-item__indicator-new-notice" />
        <div class="a-notice-list-item__sublabel">
          {{ sublabel }}
          <span v-if="important" class="a-notice-list-item__important">
            <a-tag :outline="true">重要</a-tag>
          </span>
        </div>
        <div class="a-notice-list-item__label" :style="labelStyle()">
          <slot>{{ label }}</slot>
        </div>
      </div>
      <div v-if="opwindow" class="a-notice-list-item__opwindow">
        <a-icon icon="logout-outline" color="black" />
      </div>
    </button>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AIcon from '@/components/atoms/icon';
import ATag from '@/components/atoms/tag';
export default {
  name: 'a-notice-list-item',
  components: {
    AIcon,
    ATag,
  },
  props: {
    variant: {
      type: String,
      default: null,
      validator(value) {
        return value.match(/(null|alphanumeric)/);
      },
    },
    size: {
      type: String,
      default: null,
      validator(value) {
        return value.match(/(null|small)/);
      },
    },
    class: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    labelColor: {
      type: String,
      default: '',
    },
    sublabel: {
      type: String,
      default: '',
    },
    hasIndicator: {
      type: Boolean,
      default: false,
    },
    indicatorColor: {
      type: String,
      default: '#ee3848',
    },
    icon: {
      type: String,
      default: null,
    },
    iconColor: {
      type: String,
      default: 'black',
    },
    important: {
      type: Boolean,
      default: false,
    },
    newFlag: {
      type: Boolean,
      default: false,
    },
    opwindow: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-list-item', this.variant, this.size);
      return `${baseClassName} ${this.class}`.trim();
    },
    indicatorStyle() {
      return {
        backgroundColor: this.indicatorColor,
      };
    },
  },
  methods: {
    handleClick(url) {
      window.open(url.replaceAll('%%amp%%', '&'));
    },
    labelStyle() {
      return {
        color: this.labelColor,
      };
    },
  },
};
</script>
